export default {
  // Sidebar
  'Nova OS Proativa': 'Neuer proaktiver Arbeitsauftrag',
  'Interno': 'Intern',
  'Externo': 'Extern',
  'Preventiva': 'Präventiv',
  'Preventiva Programada':  "Geplante präventive wartung",
  "Preventiva Programada Armazém": "Geplante präventive wartung Lager",
  'Reaberta': 'Wiedereröffnet',
  'Execuções': 'Ausführungen',
  'Armazém': 'Lager',
  'Frota': 'Fuhrpark',
  'Sair': 'Abmelden',
  'Inventário': 'Inventur',

  // Nova Os
  'Voltar': 'Zurück',
  'Nova OS': 'Neuer Arbeitsauftrag',
  'Operação': 'Betrieb',
  'Placa': 'Kennzeichen',
  'Segmento': 'Segment',
  'Problemas': 'Probleme',
  'Descrição do Problema': 'Problembeschreibung',
  'Gerar OS': 'Arbeitsauftrag erstellen',
  'Cancelar': 'Abbrechen',

  // OS Interna
  "Nenhum resultado encontrado": 'Kein Ergebnis gefunden',
  "Exibindo resultado": 'Ergebnis anzeigen',
  "de": 'von',
  "Aberta há": 'Geöffnet seit',
  "Concluída em": 'Abgeschlossen am',
  "Falha ao carregar os dados da OS": "Fehler beim Laden der Arbeitsauftragsdaten",
  "Falha ao carregar os itens da OS": "Fehler beim Laden der Arbeitsauftragspositionen",

  // Ordem Servico
  "Detalhes": 'Details',
  "Mostrar": 'Anzeigen',
  "Esconder": 'Ausblenden',
  "Telefone": 'Telefon',
  "Data": 'Datum',
  "Início": 'Beginn',
  "Final": 'Ende',
  "Fornecedor": 'Lieferant',
  "Tipo": 'Typ',
  "Ciclo preventiva": 'Wartungszyklus',
  "Criticidade": 'Kritikalität',
  "Previsão de Atendimento": 'Voraussichtlicher Servicetermin',
  "Atendimento do Item": 'Bearbeitung der Position',
  "Observações": 'Hinweise',
  "Imagens": 'Bilder',
  "Salvar": 'Speichern',
  "Ordens de Serviço": 'Arbeitsaufträge',
  "GERADA_CHECKLIST": "AUS EINER CHECKLISTE ERSTELLT",
  "OBS_CHECKLIST": "CHECKLISTENHINWEISE:",
  "OS_INTERNA": "INTERNER ARBEITSAUFTRAG::",

  // OS Item
  "Iniciar": 'Starten',
  "Ações": 'Aktionen',
  "Continuar": 'Fortsetzen',
  "Pausar": 'Pausieren',
  "Registrar Peças": 'Teile erfassen',
  "Cancelar OS": 'Arbeitsauftrag stornieren',
  "OS Externa": 'Externer Arbeitsauftrag',
  "Insira um serviço. Tente novamente.": 'Geben Sie eine Arbeitsleistung ein. Versuchen Sie es erneut.',
  "Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.": "Dieser Arbeitsauftrag wurde in GINFO bereits abgeschlossen. Der Vorgang kann nicht mehr geändert werden.",
  "Somente Consulta": "Nur Ansicht",
  "Ordem de Serviço Encerrada": "Arbeitsauftrag Abgeschlossen",
  "Ordem de Serviço Cancelada": "Arbeitsauftrag Storniert",

  // ModalItems
  "Serviços": 'Arbeitsleistungen',
  "SERVIÇOS": 'Arbeitsleistungen',
  "Observação": 'Hinweis',
  "Anexo de arquivos": 'Dateianhang',
  "Oops!": 'Hoppla!',
  "Tipo de arquivo não permitido.": 'Dateityp nicht zulässig.',
  "Vídeo muito grande": 'Video zu groß',
  "O limite para anexos de vídeo é de 20MB. Grave um vídeo mais curto ou reduza a qualidade antes de anexar.": 'Das Limit für Videoanhänge beträgt 20 MB. Nehmen Sie ein kürzeres Video auf oder reduzieren Sie die Qualität vor dem Anhängen.',
  "Informe o valor total dos serviços/peças": 'Geben Sie den Gesamtbetrag für Arbeitsleistungen und Teile ein.',
  "Informe o motivo do socorro em rota": 'Grund für Pannenhilfe angeben',
  "Informe o pneu utilizado neste serviço": 'Verwendeten Reifen angeben',
  "Foi trocado o pneu": 'Wurde der Reifen gewechselt?',
  "Finalizar OS": 'Arbeitsauftrag abschließen',

  // Modal peças
  "Foi utilizado Peças?": 'Wurden Teile verwendet?',
  "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!":
    "Wenn bei diesem Service Teile verwendet wurden, drücken Sie unten 'Ja'!",
  "Não": 'Nein',
  "Sim": 'Ja',

  // Modal Itens Fim
  "Informe os itens utilizados neste serviço": 'Geben Sie die bei dieser Arbeit verwendeten Teile an.',
  "Fechar": 'Schließen',
  "Peças": 'Teile',
  "Peça": 'Teil',
  "Quantidade": 'Menge',
  "Qtde": 'Menge',
  "Localização": 'Lagerort',
  "Não informado": 'Nicht angegeben',
  "Preço": 'Preis',
  "Informe o pneu novo": 'Neuen Reifen angeben',

  // Modal Pause
  "Informe a Justificativa": 'Begründung angeben',
  "Confirmar Pausa": 'Pause bestätigen',
  "Justificativa": 'Begründung',
  "Ir ao banheiro": 'Toilettenpause',
  "Fim de expediente": 'Schichtende',
  "Atendimento": 'Service',
  "Refeição": 'Essenspause',
  "Aguardando Peças": 'Warten auf Ersatzteile',
  "Auxílio externo": 'Externe Hilfe',
  'Selecione qual peça está aguardando': 'Wählen Sie das Teil aus, auf das Sie warten.',

  // Confirmar OS Externa
  "Confirmar OS Externa": 'Externen Arbeitsauftrag bestätigen',
  "Deseja realmente enviar OS": 'Möchten Sie den Arbeitsauftrag wirklich senden?',
  "Confirmar": 'Bestätigen',

  // Lista de Execucao
  "Lista de execução": 'Ausführungsliste',
  "Nenhuma execução ativa": 'Keine aktive Ausführung',
  "Início Atendimento": 'Servicebeginn',
  "Encerrar OS": 'Arbeitsauftrag abschließen',
  "Acessar OS": 'Arbeitsauftrag öffnen',
  "Colaborador": 'Mitarbeiter',
  "Execuções em Pause": 'Pausierte Ausführungen',
  "Nenhuma execução em pause": 'Keine pausierte Ausführung',

  // Login
  "Torne sua rotina mais dinâmica": 'Machen Sie Ihre Routine dynamischer',
  "ACESSO AO SISTEMA": 'SYSTEMZUGANG',
  "Terminal Oficina": 'Werkstattterminal',
  "Realize o login e tenha acesso ao controle": 'Melden Sie sich an und erhalten Sie Zugriff auf die Steuerung',
  "e gestão de suas Ordens de Serviço": 'und Verwaltung Ihrer Arbeitsaufträge.',
  "Mecânico Externo": 'Externer Mechaniker',
  "Acessar": 'Anmelden',
  "Falha ao fazer login": 'Fehler bei der Anmeldung',

  // Filtro Internas
  "Ordenar": 'Sortieren',
  "Antigas Primeiro": 'Älteste zuerst',
  "Recentes Primeiro": 'Neueste zuerst',
  "Maior": 'Größer',
  "Menor": 'Kleiner',
  "Segmentos": 'Segmente',
  "Período": 'Zeitraum',
  "Execução": 'Ausführung',
  "Todos": 'Alle',
  "Pendentes": 'Offen',
  "Finalizadas": 'Abgeschlossen',
  "Aplicar filtro": 'Filter anwenden',
  "Limpar filtros": 'Filter zurücksetzen',
  "Esconder filtros": 'Filter ausblenden',
  "Criado por": 'Erstellt von',
  "Usuário": 'Benutzer',
  "Ação": "Aktion",

  // Os Preventivas
  "Filtre as OS Preventivas": 'Präventive Aufträge filtern',
  "Preventivas Vencidas": 'Abgelaufene Präventivmaßnahmen',
  "Preventivas à Vencer": 'Anstehende Präventivmaßnahmen',
  "Carrocerias Vencidas": 'Überfällige Karosseriewartungen',
  "Carrocerias à Vencer": "Demnächst fällige Karosseriewartungen",
  "Atualizar": 'Aktualisieren',

  // Modais Preventivas
  "ACAO": 'Maßnahme',
  "PLACA": 'KENNZEICHEN',
  "PROXIMO_CICLO": 'NÄCHSTER_ZYKLUS',
  "VENCIMENTO": 'FÄLLIGKEIT',
  "PROXIMO_KM": 'NÄCHSTER_KILOMETERSTAND',
  "KM_ATUAL": 'AKTUELLER_KILOMETERSTAND',
  "Vincular Fornecedor": 'Lieferant verknüpfen',

  // Inventário
  'Iniciar novo inventário': 'Neue Inventur starten',
  'Dt Inicial': 'Anfangsdatum',
  'Dt Final': 'Enddatum',
  "Não contados": 'Nicht gezählt',
  "Contados": 'Gezählt',
  "Ordenação": 'Sortierung',
  "Total Itens": 'ARTIKEL INSGESAMT',
  "Status": "Status",
  "Já existe um inventário em execução": "Es gibt bereits eine laufende Inventur",
  "Deseja iniciar um novo inventário?": "Möchten Sie eine neue Inventur starten?",
  "Inventário de Estoque": "Lagerinventur",

  // Modal Mecanico
  "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade":
    'Geben Sie die ersten drei Ziffern Ihres CPF ein, um Ihre Identität zu bestätigen',
  'Confirmar identidade': 'Identität bestätigen',

  "Erro do Motorista": 'Fahrerfehler',
  "Defeito não Encontrado": 'Kein Defekt gefunden',

  "Informe o serviço": 'Service angeben',
  "Insira os Itens": 'Artikel eingeben',

  "Alterar Fornecedor": 'Lieferant ändern',
  "Preventivas Armazém": 'Präventive Lager',
  "Outros": 'Sonstige',
  "Ver Encerradas": 'Abgeschlossene anzeigen',
  "Tem dúvida?": 'Haben Sie Fragen?',
  "Aguardando Aprovação": 'Genehmigung ausstehend',

  // Borracharia
  'Bem vindo(a) ao Terminal da Borracharia!': 'Willkommen am Terminal der Reifenwerkstatt!',
  'Realize a gestão de pneus pelo novo terminal da borracharia!':
  'Verwalten Sie die Reifen über das neue Terminal der Reifenwerkstatt!',
  'Aferição': 'Reifenmessung',
  'Movimentação/Troca': 'Umsetzen/Wechsel',
  'Descarte': 'Entsorgung',
  'Borracharia': 'Reifenwerkstatt',
  'Placas': 'Kennzeichen',
  "Descartes": "Entsorgungen",
  // Gerais
  "Portugues": 'Portugiesisch',
  "Nunca feito": 'Nie durchgeführt',
  "Ingles": 'Englisch',
  'Frances': "Französisch",
  'Alemao': 'Deutsch',
  'Holandes': 'Niederländisch',
  'Espanhol': 'Spanisch',
  "Inventário criado com sucesso!": "Inventur erfolgreich erstellt!",

  "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "DIE ANSTRENGUNG VON HEUTE IST DER ERFOLG VON MORGEN",

  "CODIGO OS": "AUFTRAGSCODE",
  "TODOS": "ALLE",
  "Socorro em Rota pendente de atendimento": "Pannenhilfe ausstehend",
  "FILTROS": "FILTER",
  "Salvar Filtro": "Filter speichern",
  "Motorista": "Fahrer",
  "Orçamento": "Kostenvoranschlag",
  "Confirmar Orçamento": "Kostenvoranschlag bestätigen",
  "Deseja pausar esta OS para aguardar o orçamento?": "Möchten Sie den Arbeitsauftrag pausieren, um auf den Kostenvoranschlag zu warten?",
  "Valor": "Betrag",
  "Pausar OS": "Arbeitsauftrag pausieren",
  "Comentarios": "Kommentare",
  "Insira um comentário": "Kommentar eingeben",
  "Enviar OS": "Arbeitsauftrag senden",
  "Selecione uma justificativa": "Begründung auswählen",
  "Anexos": "Anhänge",
  "OS Socorro em Rotas": "Arbeitsauftrag Pannenhilfe",
  "Confirmar Cancelamento": "Stornierung bestätigen",
  "Buscar Placa": "Kennzeichen suchen",
  "Pesquisa de OS por placa": "Arbeitsauftragssuche nach Kennzeichen",
  "CONTRATO_CONCESSIONARIA": "HÄNDLERVERTRAG",

  "Ordem gerada com sucesso": "Auftrag erfolgreich erstellt",
  "Sucesso": "Erfolg",
  "Selecionar Todos": "Alle auswählen",
  "Descrição": "Beschreibung",
  "Registrar Serviços": "Arbeitsleistungen erfassen",
  "Visualizar Itens": "Positionen anzeigen",
  "Clique no botão a direita para registrar as peças": "Klicken Sie auf die Schaltfläche rechts, um die Teile zu registrieren",

  "Selecionar técnico": "Techniker auswählen",
  "KM atual/Horimetro": "Aktueller Kilometer-/Betriebsstundenstand",
  "Deseja inserir alguma imagem no atendimento": "Möchten Sie dem Einsatz ein Bild hinzufügen?",
  "Para concluir a ação, selecione abaixo o técnico responsável": "Um die Aktion abzuschließen, wählen Sie unten den verantwortlichen Techniker aus",
  "Trabalhando": "In Arbeit",
  "Matricula": "MITARBEITER-NR",
  "Serviços registrado com sucesso": "Arbeitsleistungen erfolgreich erfasst",
  "Função": "Funktion",
  "Enviar Anexos": "Anhänge senden",
  "Gerar Preventiva Programada": "Geplanten Wartungsauftrag erstellen",
  "OS Preventiva Programada": "Geplanter Wartungsauftrag",
  "Finalize todas as peças e serviços para encerrar o atendimento": "Schließen Sie alle Teile und Dienstleistungen ab, um den Auftrag zu beenden",
  "Insira um KM maior que o anterior": "Geben Sie einen Kilometerstand ein, der höher als der vorherige ist",
  "Insira um KM maior que o atual": "Geben Sie einen Kilometerstand ein, der höher als der aktuelle ist",
  "Inserir anexos": "Anhänge hinzufügen",
  "Planos Preventivos": "Präventive Pläne",
  "Filtro": "Filter",
  "ULTIMA": "LETZTE",
  "Gerar Preditiva": "Prädiktiven Wartungsauftrag erstellen",
  "Carregando": "Wird geladen…",
  "OS Preventiva Programada Armazém": "Geplanter Wartungsauftrag – Lager",
  "Gerar OS Preventiva Programada": "Geplanten Wartungsauftrag erstellen",
  "OS Preventivas à Vencer": "Präventive Arbeitsaufträge vor Fälligkeit",
  "OS de Transição": "Übergangsarbeitsauftrag",

  "IMEDIATA": "SOFORT",
  "EMERGENCIAL": "NOTFALL",
  "ALTA": "HOCH",
  "MÉDIA": "MITTEL",
  "LEVE": "NIEDRIG",

  "Registrar Tarefas": "Aufgaben Registrieren",
  "Desbloqueia Empilhadeira": "Gabelstapler Entriegeln",
  "OS Ag. Aprovação": "Arbeitsauftrag wartet auf Genehmigung",
  "OS Internas Veículos": "Interne Aufträge – Fahrzeuge",
  "OS Internas Armazém": "Interne Aufträge – Lager",
  "OS Reabertas": "Wiedereröffnete Arbeitsaufträge",
  "Criticidade de OS Abertas": "Kritikalität offener Arbeitsaufträge",
  "Top 20 Placas com mais OS": "Top 20 Kennzeichen mit den Meisten Aufträgen",
  "Qtd OS": "Anzahl der Arbeitsaufträge",

  // Dashboard
  "Criticidade de OS abertas": "Kritikalität offener Aufträge",
  "URGENTE": "DRINGEND",
  "PREVENTIVA": "PRÄVENTIV",
  "CRITICIDADES": "KRITIKALITÄTEN",
  "Bem Vindo(a)": "Willkommen",
  "Tenha acesso as principais": "Erhalten Sie Zugang zu den wichtigsten",
  "informações da sua mecânica!": "Informationen Ihrer Werkstatt!",
  "Ver OS internas": "Interne Aufträge anzeigen",
  "OS TicketLog": "TicketLog-Arbeitsauftrag",
  "OS Externas": "Externe Aufträge",
  "OS Interna Veículos": "Interner Auftrag Fahrzeuge",
  "OS Interna Armazém": "Interner Auftrag Lager",
  "Ranking dos Mecânicos": "Mechaniker-Ranking",
  "Tipo de OS": "Arbeitsauftragstyp",
  "Atendidas nos últimos 30 dias": "In den letzten 30 Tagen bearbeitet",
  "TOP 20 Placas com mais OS": "TOP 20 Kennzeichen mit den meisten Aufträgen",
  "Últimos 30 dias": "Letzte 30 Tage",
  "Placas com OS Externas": "Kennzeichen mit externen Arbeitsaufträgen",
  "TOP 10 Problemas mais atendidos": "TOP 10 Meist bearbeitete Probleme",
  "Nos últimos 30 dias": "In den letzten 30 Tagen",
  "Status por Mecânico": "Status nach Mechaniker",
  "Produtividade": "Produktivität",

  // ModalEncerradas
  "Filtros": "Filter",
  "NÚMERO": "NUMMER",
  "INÍCIO": "BEGINN",
  "FINAL": "ENDE",
  "SEGMENTO": "SEGMENT",
  "PROBLEMA": "PROBLEM",

  // Login
  "Acesso Rápido": "Schnellzugriff",
  "ID": "ID",
  "CNPJ": "ID",
  "codigo_fornec": "Lieferantencode",
  "Para qual fornecedor você deseja enviar esta OS": "An welchen Lieferanten möchten Sie diesen Arbeitsauftrag senden?",
  'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': "Falls Teile für diesen Service verwendet wurden, drücken Sie unten auf „Ja“!",
  'Precisa de Ajuda?': 'Hilfe benötigt?',
  "FILTRO EMPRESA": "UNTERNEHMENSFILTER",
  "Upload Arquivos": "Dateien hochladen",
  "Cards": "Cards",
  "Colunas": "Spalten",
  "ULTIMA MM": "LETZTE MM",
  "PRÓXIMA MM": "NÄCHSTE MM",
  "ULTIMA CAL": "LETZTE CAL",
  "PRÓXIMA CAL": "NÄCHSTE CAL",

  "ULTIMA MOVIMENTACAO": "LETZTE BEWEGUNG",
  "PRÓXIMA MOVIMENTACAO": "NÄCHSTE BEWEGUNG",
  "N° FOGO": "REIFENKENNNR",
  "FILIAL": "ZWEIG",
  "MARCA": "MARKE",
  "MODELO": "MODELL",
  "MEDIDA": "MAß",
  "POSIÇÃO": "POSITION",
  "Aguardando Aprovação de Sinistro": "Warten auf Schadensgenehmigung",
  "Aguardando Liberacao": "Warten auf Freigabe",
  "Nenhuma OS aguardando liberacao": "Keine Arbeitsaufträge warten auf Freigabe",

  "O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão":
  "Die Gesamtzeit beträgt weniger als 5 Minuten. Dies kann sich negativ auf die Managementkontrolle auswirken",

  "Aguardar Liberação": "Freigabe ausstehend",

  // "CONTRATO CONCESSIONARIA": "HÄNDLERVERTRAG",
  "Nenhuma OS aguardando aprovação": "Keine Arbeitsaufträge warten auf Genehmigung",

    // Chaves adicionadas para i18n completo
    "Adicionar Serviços": "Arbeitsleistungen hinzufügen",
    "Aferindo NR Fogo": "Reifenmessung nach Kennnummer",
    "AFERIÇÃO": "REIFENMESSUNG",
    "Aderência Aferição 01": "Erfüllungsquote der Reifenmessung",
    "Aderência Aferição 02": "Erfüllungsquote der Reifenmessung",
    "AÇÃO": "AKTION",
    "CALIBRAGEM": "KALIBRIERUNG",
    "CD_PNEU": "REIFEN_CODE",
    "CONJUNTO": "SATZ",
    "CPF (3 primeiros digitos)": "CPF (erste 3 Ziffern)",
    "Cadastro": "Registrierung",
    "Calibragem NR Fogo": "Reifendruckkontrolle nach Reifenkennnummer",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo": "Geben Sie den Lieferantennamen ein, um ihn in der Liste unten anzuzeigen",
    "Confirmar envio Ticket": "Ticketversand bestätigen",
    "Conserto de Pneus": "Reifenreparatur",
    "DATA": "DATUM",
    "DS_PREDITIVO": "PRÄDIKTIVE BESCHREIBUNG",
    "DashBoard": "Dashboard",
    "Dashboard": "Dashboard",
    "Data Final": "Enddatum",
    "Data Inicial": "Startdatum",
    "Data OS": "Datum des Arbeitsauftrags",
    "Dentro do Prazo": "Fristgerecht",
    "Descartar": "Verwerfen",
    "Descarte Pneus": "Reifenentsorgung",
    "Deseja enviar para TicketLog a OS": "Möchten Sie die OS an TicketLog senden",
    "Digite para pesquisar": "Zum Suchen tippen",
    "Enviar": "Senden",
    "Equipamento Liberado": "Gerät freigegeben",
    "Escreva seu script aqui": "Schreiben Sie Ihr Skript hier",
    "Externas Armazém": "Externe Lager",
    "FOGO": "REIFENKENNNUMMER",
    "Fora do Prazo": "Überfällig",
    "Informar Aferição": "Reifenmessung eingeben",
    "Informar Calibragem": "Reifendruck eingeben",
    "Informar KM": "Kilometerstand eingeben",
    "Informar Sinistro": "Schaden melden",
    "Informe o KM do Pneu": "Reifenlaufleistung eingeben",
    "Informe o serviço feito!": "Ausgeführten Service angeben!",
    "Insira o KM do veículo:": "Kilometerstand des Fahrzeugs eingeben:",
    "Insira os Serviços": "Geben Sie die Arbeitsleistungen ein",
    "Inventário de estoque": "Lagerinventur",
    "Inverter pneus": "Reifen umsetzen",
    "Início Atendimento OS": "OS-Servicebeginn",
    "Item": "Artikel",
    "Itens:": "Artikel:",
    "KM": "KM",
    "KM PROX.": "NÄCHSTER KILOMETERSTAND",
    "Lançamento de item": "Artikelbuchung",
    "Lista": "Liste",
    "Matrícula": "Personalnummer",
    "Motivo": "Grund",
    "NR Fogo": "Reifenkennnummer",
    "Novas Aferições": "Neue Reifenmessungen",
    "OS Encerradas - Últimas 15 OS": "Abgeschlossene Arbeitsaufträge – letzte 15",
    "OS Preventiva Vencida": "Überfällige präventive OS",
    "OS Preventivas Vencidas": "Überfällige präventive OS",
    "Observacao": "Hinweis",
    "PROX. CICLO": "NÄCHSTER ZYKLUS",
    "Para qual fornecedor você deseja enviar esta OS?": "An welchen Lieferanten möchten Sie diese OS senden?",
    "Pendente": "Ausstehend",
    "Pesquisa global": "Globale Suche",
    "Pesquisar": "Suchen",
    "Pesquisar Item": "Artikel suchen",
    "Pesquisar peça": "Teil suchen",
    "Pesquisar serviço": "Arbeitsleistung suchen",
    "Planos": "Pläne",
    "Pneus a Placa:": "Reifen für Kennzeichen:",
    "Problema": "Problem",
    "Próximo Ciclo": "Nächster Zyklus",
    "Pular": "Überspringen",
    "Realizar avaliação": "Bewertung durchführen",
    "Registrar Aferições": "Reifenmessungen erfassen",
    "Selecione a empresa": "Unternehmen auswählen",
    "Selecione um Pneu": "Reifen auswählen",
    "Selecione um fornecedor": "Lieferanten auswählen",
    "Selecione um motivo": "Grund auswählen",
    "Servicos": "Arbeitsleistungen",
    "Serviço": "Arbeitsleistung",
    "Sinalizar Sinistro": "Schaden melden",
    "Sucesso!": "Erfolg!",
    "TIPO": "TYP",
    "Vencimento": "Fälligkeit",
    "de Calibragem": "der Reifendruckkontrolle",
    "Última Aferição": "Letzte Reifenmessung",
    "Última aferição NR fogo": "Letzte Reifenmessung nach Kennnummer",

    // Mensagens de validação
    "Preenchimento obrigatório": "Pflichtfeld",
    "Disponível": "Verfügbar",
    "Deve ser maior que 0": "Muss größer als 0 sein",
    "Não pode ser negativo": "Darf nicht negativ sein",
    "Valor Unitário": "Stückpreis",
    "Existem filtros salvos e aplicados": "Es gibt gespeicherte und angewendete Filter",
    "Adicionar Arquivos": "Dateien hinzufügen",
    "Ordem de Serviço criada com Sucesso": "Arbeitsauftrag erfolgreich erstellt",
    "Falha ao parar execução. Tente novamente": "Ausführung konnte nicht gestoppt werden. Bitte versuchen Sie es erneut.",
"Selecionar": "Auswählen",
"Insira todas as informações": "Geben Sie alle Informationen ein",
"Item registrado com sucesso": "Artikel erfolgreich erfasst",
"Insira um preço": "Geben Sie einen Preis ein",
"OS Preventiva A Vencer": "Präventive Arbeitsaufträge mit bevorstehender Fälligkeit",
"OS já está aberta": "Der Arbeitsauftrag ist bereits geöffnet",
"Não trabalhando": "Nicht im Einsatz",

"ABASTECIMENTO": "BETANKUNG",
"CHECKLIST": "CHECKLISTE",
"CHECKLIST CONFORMIDADE": "KONFORMITÄTSCHECKLISTE",
"PREVENTIVA CARROCERIA": "VORBEUGENDE KAROSSERIEWARTUNG",
"SOCORRO EM ROTA": "PANNENHILFE",
"finalizado": "Abgeschlossen",
"contagem": "Zählung",
"contagem_de_itens": "Artikelzählung",
"codigo": "Code",
"saldo_atual": "Aktueller Bestand",
"item_nao_registrado_tente_novamente": "Artikel nicht registriert, bitte versuchen Sie es erneut",
"versao": "Version",
"informe_a_leitura_de_todos_os_sulcos": "Geben Sie die Messung aller Profilrillen ein",
"Faça a leitura de todos os pneus para registrar": "Messen Sie alle Reifen, um die Werte zu erfassen.",
"Leitura registrada com sucesso": "Messung erfolgreich erfasst",


    // Anexos do descarte de pneus
    "Anexar documento": "Dokument anhängen",
    "Selecione o tipo do documento e o arquivo para anexar ao descarte": "Wählen Sie den Dokumenttyp und die Datei aus, die der Entsorgung beigefügt werden soll",
    "Tipo de documento": "Dokumenttyp",
    "Selecione um anexo": "Wählen Sie einen Anhang",
    "Adicionar documento": "Dokument hinzufügen",
    "Extensão não permitida": "Erweiterung nicht zulässig",
    "Arquivo excede o tamanho máximo de": "Die Datei überschreitet die maximale Größe von",
    "Informe o tipo do documento": "Geben Sie den Dokumenttyp an",
    "Descarte realizado, mas falhou o envio dos anexos": "Entsorgung durchgeführt, aber das Senden der Anhänge ist fehlgeschlagen",
    "Descarte realizado com sucesso!": "Entsorgung erfolgreich durchgeführt!",
    "Erro ao descartar pneu, tente novamente!": "Fehler beim Entsorgen des Reifens, bitte versuchen Sie es erneut!",
    "Informe o KM atual!": "Geben Sie den aktuellen Kilometerstand an!",

    "Selecione um Fornecedor": "Wählen Sie einen Lieferanten",
    "Preencha todas as informações": "Füllen Sie alle Informationen aus",
    "Origem": "Herkunft",
    "Interna": "Intern",
    "Externa": "Extern",
}
